export default __webpack_public_path__ + "static/media/safari_scr_1.7781b10a.png";